import { createFocusTrap } from '@theme/utils';

class ProductCard extends HTMLElement {
  connectedCallback() {
    this.cacheElements();
    this.setupEventListeners();
    this.setupPopupFocusTrap();
  }

  cacheElements() {
    // Cache all quantity controls
    this.quantityInput = this.querySelector('[js-product-card="quantity"]');
    this.popupQuantityInput = this.querySelector('[js-product-card="popup-quantity"]');
    this.quantityButtons = this.querySelectorAll('[js-product-card^="increment"], [js-product-card^="decrement"], [js-product-card^="popup-"]');
  }

  setupEventListeners() {
    this.quantityButtons.forEach(button => {
      button.addEventListener('click', this.handleQuantityChange.bind(this));
    });
  }

  setupPopupFocusTrap() {
    // Find the popup element (could be inside or outside this component)
    const popupId = this.querySelector('[popovertarget]')?.getAttribute('popovertarget');
    if (!popupId) return;

    const popup = document.getElementById(popupId);
    if (!popup) return;

    this.popupFocusTrap = createFocusTrap(popup);

    // Listen for popover toggle events
    popup.addEventListener('toggle', (event) => {
      const isOpen = popup.matches(':popover-open');

      if (isOpen) {
        this.popupFocusTrap.enable();

        // Focus the close button when popup opens
        const closeButton = popup.querySelector('.product-card-popup__close');
        if (closeButton) {
          setTimeout(() => {
            closeButton.focus();
          }, 0);
        }
      } else {
        this.popupFocusTrap.disable();
      }
    });

    popup.addEventListener('click', (event) => {
      if (event.target === popup) {
        popup.hidePopover();
      }
    });
  }

  disconnectedCallback() {
    if (this.popupFocusTrap) {
      this.popupFocusTrap.disable();
    }
  }

  handleQuantityChange(event) {
    const button = event.currentTarget;
    const action = button.getAttribute('js-product-card');
    const isIncrement = action.includes('increment');

    if (!this.quantityInput || !this.popupQuantityInput) return;

    const currentValue = parseInt(this.quantityInput.value) || 0;
    const newValue = isIncrement ? currentValue + 1 : Math.max(0, currentValue - 1);

    // Update both inputs synchronously
    this.quantityInput.value = newValue;
    this.popupQuantityInput.value = newValue;

    // Dispatch custom event
    this.dispatchEvent(new CustomEvent('productQuantityChanged', {
      detail: { productId: this.quantityInput.dataset.productId, quantity: newValue, productCard: this },
      bubbles: true
    }));
  }
}

customElements.define('product-card', ProductCard);
